import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import type { DocumentItem } from '@document-explorer/core';

@Component({
  selector: 'de-selection-bar',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (selected().length > 0) {
      <div class="de-selection-bar" role="status">
        <span>{{ selected().length }} {{ selected().length === 1 ? 'item' : 'items' }} selected</span>
        <div class="de-selection-actions">
          @if (canSelectAll()) {
            <button type="button" class="de-button de-button--quiet" (click)="selectAll.emit()">Select all</button>
          }
          <button type="button" class="de-button de-button--quiet" (click)="clear.emit()">Clear</button>
        </div>
      </div>
    }
  `,
})
export class DeSelectionBarComponent {
  readonly selected = input<DocumentItem[]>([]);
  readonly canSelectAll = input<boolean>(true);
  readonly clear = output<void>();
  readonly selectAll = output<void>();
}
